import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IMonthlyActiveUser } from '@/shared/model/monthly-active-user.model';

const baseApiUrl = 'api/monthly-active-users';
const baseSearchApiUrl = 'api/_search/monthly-active-users?query=';

export default class MonthlyActiveUserService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IMonthlyActiveUser> {
    return new Promise<IMonthlyActiveUser>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IMonthlyActiveUser): Promise<IMonthlyActiveUser> {
    return new Promise<IMonthlyActiveUser>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IMonthlyActiveUser): Promise<IMonthlyActiveUser> {
    return new Promise<IMonthlyActiveUser>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
